<template>
  <md-layout mdAlign="center">
    <div class="half">
      <md-card>
        <md-card-header>
          <md-whiteframe md-tag="md-toolbar" md-elevation="2" class="md-medium">
            <div class="md-toolbar-container"></div>
            <div class="md-toolbar-container">
              <h2 class="md-title">Seleção de Organização do Jira</h2>
            </div>
          </md-whiteframe>
        </md-card-header>

        <md-card-content class="scrolable">

          <md-input-container>
            <label for="customer">Organização</label>
            <md-select name="Customer" id="customer" v-model="selectedCustomer" v-on:change="putOrganization">
              <md-option v-for="customer in customers" :key="customer.id" :value="customer">{{customer}}</md-option>
            </md-select>
          </md-input-container>

        </md-card-content>
      </md-card>
      <md-snackbar :md-position="snack.vertical + ' ' + snack.horizontal" ref="snackbar" :md-duration="snack.duration">
        <span>{{snack.message}}</span>
        <md-button class="md-accent" @click="$refs.snackbar.close()">Ok</md-button>
      </md-snackbar>
    </div>
  </md-layout>
</template>

<script>
  import ticketsService from "../services/TicketsService";
  import AuthService from "../services/AuthService";
  import router from "../router/index";
  import LocalMessageService from "../services/LocalMessageService";

  export default {
    data(){
      return {

        selectedCustomer: null,

        customers: [],

        snack: {
          vertical: 'bottom',
          horizontal: 'center',
          duration: 6000,
          message: null
        },

        authToken: null
      }
    },

    created(){
      this.authToken = AuthService.getToken();
      AuthService.removeToken();
      this.findAllCustomers();
    },

    methods: {

      findAllCustomers: function () {
        ticketsService.findAllCustomers().then((success) => {
          this.customers = success.body;
        });
      },

      putOrganization: function (organizationName) {
        if(organizationName){
          ticketsService.putOrganization(organizationName).then((success) => {
            AuthService.addToken(this.authToken);
            router.push({path: '/'});
          }, (error) => {
            router.push({path: '/login'});
          })
        }
      }

    }

  }

</script>

<style>
  .half{
    width: 60%;
  }

  .full{
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/SecondStepLogin.vue